import i18n from "i18next";
import en from "./i18n/en.json";
import { initReactI18next } from "react-i18next";

export const defaultLanguage = "en";

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
  },
  lng: "en", // default language
  fallbackLng: "en", // fallback language
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
